var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_vm._v("firebase test")]),_c('div',[_c('div',{staticClass:"btn btn-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onSignInClick.apply(null, arguments)}}},[_vm._v(" signin ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }